/**
 * 学生路由
  */
// import Layout from '@/baseLayout/LayoutPage'
const roleStudent = "students"
export const routesS = {
    path: "/student",
    name:"student",
    // component:Layout,
    redirect:"/student/apply",
        children:[
            {
                path: 'apply',
                // component: () => import(/* webpackChunkName: "about" */ '../views/students/ApplicationForm.vue'),
                meta:{title:"申请表",menuShow:true,role:roleStudent}
            },
            {
                path: 'applydetail',
                // component: () => import(/* webpackChunkName: "about" */ '../views/students/ApplicationRecord.vue'),
                meta:{title:"申请记录",menuShow:true,role:roleStudent}
            },
        ]
    }


